import React from "react";
import FootMassageHead from "./FootMassageHead";
import FootMassagePara from "./FootMassagePara";
import "../NearMe.css";

const FootMassageMain = () => {
  return (
    <div className="nearContainer">
      <FootMassageHead />
      <FootMassagePara />
    </div>
  );
};

export default FootMassageMain;
